export default "__VITE_ASSET__54c08d0b__"